// @ts-nocheck
import React, { useEffect, useState, useReducer, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { ListBox } from 'primereact/listbox';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Slider } from 'primereact/slider';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';
import { InputNumber } from 'primereact/inputnumber';
import { ColorPicker } from 'primereact/colorpicker';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"
import { Card } from 'primereact/card';

export const SatelliteModuleComponents = (props) => {
    const [militaryModule, setMilitaryModule] = useState(null);
    const [satelliteItem, setSatelliteItem] = useState([]);
    const [selectSatelliteItem, setSelectSatelliteItem] = useState([]);
    const [siderValue, setSiderValue] = useState(1);
    const [useTimeLine, setUseTimeLine] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [apiKey, setApiKey] = useState("");
    const [hoveTimeSpanValue, setHoveTimeSpanValue] = useState([]);
    const [, forceUpdate] = useReducer(num => num + 1, 0);
    const toast = useRef(null);

    useEffect(() => {
        setSatelliteItem(window.SPECIALAPPLICATION_MODULE_LIST.SATELLITETLE);
    }, []);

    useEffect(() => {
        if (selectSatelliteItem.length === 0)
            return;
        if (useTimeLine) {
            selectSatelliteItem.forEach((item) => {
                item.entity.play = false;
                window.widgetTimeline.addLink(item.entity);
            })
        }
        else {
            selectSatelliteItem.forEach((item) => {
                window.widgetTimeline.removeLink(item.entity);
                item.entity.play = true;
            })
        }
    }, [useTimeLine]);

    useEffect(() => {
        if (selectSatelliteItem.length === 0)
            return;
        selectSatelliteItem.forEach((item) => {
            if (item.entity)
                item.entity.update({ playSpeed: siderValue });
        })
    }, [siderValue]);

    const satelliteItemOnChange = (items) => {
        if (selectSatelliteItem.length > items.length) {
            satelliteItemRemove(items);
            return;
        }
        satelliteItemOpen(items);
    }

    const satelliteItemRemove = (items) => {
        let entity = null;
        for (let i = 0; i < selectSatelliteItem.length; i++) {
            if (selectSatelliteItem[i] !== items[i]) {
                entity = selectSatelliteItem[i].entity;
                break;
            }
        }
        militaryModule.removeEntity(entity);
        setSelectSatelliteItem(items);
    }

    const satelliteItemOpen = (items) => {
        if (selectSatelliteItem.length === 0) {
            let Camera = window.main.OView.camera;
            Camera.pos.z = 16403000;
            window.main.OView.gotoCamera(Camera, true);
        }
        let item = items[items.length - 1];
        let title = item.title;
        let tleLine1 = item.tleLine1;
        let tleLine2 = item.tleLine2;
        let satelliteFOV = item.satelliteFOV;
        let icon = item.icon;
        let iconSize = item.iconSize;
        let orbitDetail = item.orbitDetail;
        let showSatellite = item.showSatellite;
        let showOrbit = item.showOrbit;
        let showViewCone = item.showViewCone;
        let showGroundLine = item.showGroundLine;
        let satelliteColor = item.color;
        let Module = militaryModule
        if (Module === undefined || Module === null) {
            Module = window.main.OView.getModule("military");
            setMilitaryModule(Module);
        }
        var param = {};
        param.tleTitle = title;
        param.tleLine1 = tleLine1;
        param.tleLine2 = tleLine2;
        param.satelliteFOV = satelliteFOV;
        param.icon = icon;
        param.iconSize = iconSize;
        param.orbitDetail = orbitDetail;
        param.showSatellite = showSatellite;
        param.showOrbit = showOrbit;
        param.showViewCone = showViewCone;
        param.showGroundLine = showGroundLine;
        param.playSpeed = siderValue;
        param.satelliteColor = new window.ov.Color(satelliteColor);
        item.entity = Module.addSatelliteEntity(param);
        if (useTimeLine) {
            window.widgetTimeline.addLink(item.entity);
        }
        items[items.length - 1] = item;
        setSelectSatelliteItem(items);
    }

    const newSatelliteItemChange = (item) => {
        let items = [...satelliteItem];
        let selectItems = [...selectSatelliteItem];
        items.push(item);
        selectItems.push(item);
        setSatelliteItem(items);
        satelliteItemOnChange(selectItems);
    }

    const editSatelliteItemChange = (oldItem, item) => {
        let items = [...satelliteItem];
        let selectItems = [...selectSatelliteItem];
        items.forEach((selectItem) => {
            if (selectItem.title === oldItem.title) {
                selectItem.title = item.title;
                selectItem.tleLine1 = item.tleLine1;
                selectItem.tleLine2 = item.tleLine2;
                selectItem.color = item.color;
                selectItem.icon = item.icon;
                selectItem.iconSize = item.iconSize;
                selectItem.satelliteFOV = item.satelliteFOV;
                selectItem.orbitDetail = item.orbitDetail;
            }
        })
        selectItems.forEach((selectItem) => {
            if (selectItem.title === oldItem.title) {
                let param = {};
                param.tleTitle = selectItem.title = item.title;
                param.tleLine1 = selectItem.tleLine1 = item.tleLine1;
                param.tleLine2 = selectItem.tleLine2 = item.tleLine2;
                param.satelliteColor = selectItem.color = item.color;
                param.icon = selectItem.icon = item.icon;
                param.iconSize = selectItem.iconSize = item.iconSize;
                param.satelliteFOV = selectItem.satelliteFOV = item.satelliteFOV;
                param.orbitDetail = selectItem.orbitDetail = item.orbitDetail;
                selectItem.entity.update(param);
            }
        })
        setSatelliteItem(items);
        setSelectSatelliteItem(selectItems);
        toast.current.show({ severity: 'success', summary: '衛星模組提示', detail: "衛星更新成功！" });
        forceUpdate();
    }

    const deleteSatelliteItem = (item) => {
        let items = [...satelliteItem];
        let selectItems = [...selectSatelliteItem];
        items.forEach((selectItem, index) => {
            if (selectItem.title === item.title) {
                items.splice(index, 1);
            }
        })
        selectItems.forEach((selectItem, index) => {
            if (selectItem.title === item.title) {
                militaryModule.removeEntity(selectItem.entity);
                selectItems.splice(index, 1);
            }
        })
        setSatelliteItem(items);
        setSelectSatelliteItem(selectItems);
        toast.current.show({ severity: 'success', summary: '衛星模組提示', detail: "衛星刪除成功！" });
    }

    return (
        <Dialog header="衛星軌道模組" visible={props.SatelliteModule} modal={false} keepInViewport={false} onHide={() => props.onHide('SatelliteModule')} className="SatelliteModule-Dialog">
            <Toast ref={toast} />
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="衛星列表">
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">跟隨時間軸：</label>
                        <div className="col-12 md:col-8">
                            <InputSwitch checked={useTimeLine} onChange={(e) => setUseTimeLine(e.value)} />
                        </div>
                    </div>
                    {
                        useTimeLine ? null :
                            <div>
                                <label>運行速度： {siderValue}倍速</label>
                                <Slider id="lightZenith" value={siderValue} onChange={(e) => setSiderValue(e.value)} min={-1000} max={1000} />
                            </div>
                    }
                    <Divider />
                    <ListBox value={selectSatelliteItem} options={satelliteItem} filter multiple onChange={(e) => satelliteItemOnChange(e.value)} optionLabel="title" />
                </TabPanel>
                <TabPanel header="新增衛星">
                    <NewSatelliteItem newSatelliteItemChange={newSatelliteItemChange} satelliteItem={satelliteItem} apiKey={apiKey} setApiKey={setApiKey} />
                </TabPanel>
                <TabPanel header="修改衛星">
                    <EditSatelliteItem satelliteItem={satelliteItem} editSatelliteItemChange={editSatelliteItemChange} deleteSatelliteItem={deleteSatelliteItem} />
                </TabPanel>
                <TabPanel header="衛星過頂分析">
                    <SatelliteHoveTimeSpan selectSatelliteItem={selectSatelliteItem} hoveTimeSpanValue={hoveTimeSpanValue} setHoveTimeSpanValue={setHoveTimeSpanValue} />
                </TabPanel>
            </TabView>
        </Dialog>
    );
}

const NewSatelliteItem = (props) => {
    const model = [
        { label: '使用N2YO.com匯入衛星', value: 0 },
        { label: '使用TLE軌道匯入衛星', value: 1 }
    ];
    const [selectModel, setSelectModel] = useState(0);
    const [title, setTitle] = useState("");
    const [ID, setID] = useState("");
    const [color, setColor] = useState("FF0000");
    const [tleLine1, setTLELine1] = useState("");
    const [tleLine2, setTLELine2] = useState("");
    const [icon, setIcon] = useState("img/1-2-satellite-free-download-png.png");
    const [iconSize, setIconSize] = useState(30);
    const [satelliteFOV, setSatelliteFOV] = useState(45);
    const [orbitDetail, setOrbitDetail] = useState(90);
    const [isLoad, setIsLoad] = useState(false);
    const [isCanSend, setIsCanSend] = useState(false);
    const toast = useRef(null);

    useEffect(() => {
        if (selectModel === 0) {
            if (props.apiKey.length > 0 && ID.length > 0) {
                setIsCanSend(true);
            }
            else {
                setIsCanSend(false);
            }
        }
        else {
            if (title.length > 0 && tleLine1.length > 0 && tleLine2.length > 0) {
                setIsCanSend(true);
            }
            else {
                setIsCanSend(false);
            }
        }
    }, [selectModel, title, ID, props.apiKey, tleLine1, tleLine2])

    const newSatelliteOnClick = () => {
        if (selectModel === 0) {
            let url = "Oview.aspx?" + window.SATELLITETLE_SOURCE[0].url + ID + "&apiKey=" + props.apiKey;
            setIsLoad(true);
            fetch(url)
                .then((response) => {
                    return response.json();
                })
                .then((event) => {
                    if (event.error) {
                        toast.current.show({ severity: 'error', summary: '衛星模組提示', detail: event.error });
                        setIsLoad(false);
                        return;
                    }
                    else if (event.tle === "") {
                        toast.current.show({ severity: 'error', summary: '衛星模組提示', detail: "衛星編號錯誤，請查明後重試！" });
                        setIsLoad(false);
                        return;
                    }
                    let ishave = false;
                    props.satelliteItem.forEach(
                        (item) => {
                            if (item.title === event.info.satname)
                                ishave = true;
                        }
                    )
                    if (ishave) {
                        toast.current.show({ severity: 'error', summary: '衛星模組提示', detail: "衛星已在列表內！" });
                        setIsLoad(false);
                        return;
                    }
                    let item = {
                        satelliteFOV: satelliteFOV,
                        icon: icon,
                        iconSize: iconSize,
                        orbitDetail: orbitDetail,
                        showSatellite: true,
                        showOrbit: true,
                        showViewCone: true,
                        showGroundLine: true,
                        color: "#" + color,
                        entity: null
                    };
                    item.title = event.info.satname;
                    let tle = event.tle.split('\r\n')
                    item.tleLine1 = tle[0];
                    item.tleLine2 = tle[1];
                    props.newSatelliteItemChange(item);
                    toast.current.show({ severity: 'success', summary: '衛星模組提示', detail: "衛星新增成功！" });
                    setIsLoad(false);
                    setID("");
                    return;
                });
        }
        else {
            let ishave = false;
            props.satelliteItem.forEach(
                (item) => {
                    if (item.title === title)
                        ishave = true;
                }
            )
            if (ishave) {
                toast.current.show({ severity: 'error', summary: '衛星模組提示', detail: "衛星已在列表內！" });
                setIsLoad(false);
                return;
            }
            let item = {
                title: title,
                tleLine1: tleLine1,
                tleLine2: tleLine2,
                satelliteFOV: satelliteFOV,
                icon: icon,
                iconSize: iconSize,
                orbitDetail: orbitDetail,
                showSatellite: true,
                showOrbit: true,
                showViewCone: true,
                showGroundLine: true,
                color: "#" + color,
                entity: null
            };
            props.newSatelliteItemChange(item);
            toast.current.show({ severity: 'success', summary: '衛星模組提示', detail: "衛星新增成功！" });
            setIsLoad(false);
            setTitle("");
            setTLELine1("");
            setTLELine2("");
            return;
        }
    }

    return (
        <div>
            <Toast ref={toast} />
            <Dropdown className="inputfield w-full" value={selectModel} options={model} onChange={(e) => setSelectModel(e.value)} optionLabel="label" />
            <Divider />
            {
                selectModel === 0 ?
                    <div>
                        <div className="field grid">
                            <label class="col-12 mb-4 md:col-4 md:mb-0">衛星ID：</label>
                            <div className="col-12 md:col-8">
                                <InputText value={ID} onChange={(e) => setID(e.target.value)} placeholder="ex:25616" style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="field grid">
                            <label class="col-12 mb-4 md:col-4 md:mb-0">API Key：</label>
                            <div className="col-12 md:col-8">
                                <InputText value={props.apiKey} onChange={(e) => props.setApiKey(e.target.value)} placeholder="請至N2YO.com取得API Key" style={{ width: "100%" }} />
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="field grid">
                            <label class="col-12 mb-4 md:col-4 md:mb-0">衛星名稱：</label>
                            <div className="col-12 md:col-8">
                                <InputText value={title} onChange={(e) => setTitle(e.target.value)} style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="field grid">
                            <label class="col-12 mb-4 md:col-4 md:mb-0">TLE1：</label>
                            <div className="col-12 md:col-8">
                                <InputText value={tleLine1} onChange={(e) => setTLELine1(e.target.value)} style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="field grid">
                            <label class="col-12 mb-4 md:col-4 md:mb-0">TLE2：</label>
                            <div className="col-12 md:col-8">
                                <InputText value={tleLine2} onChange={(e) => setTLELine2(e.target.value)} style={{ width: "100%" }} />
                            </div>
                        </div>
                    </div>
            }
            <div className="field grid">
                <label htmlFor="coverDropdown" class="col-12 mb-4 md:col-4 md:mb-0">衛星顏色</label>
                <div className="col-12 md:col-8" style={{ alignSelf: 'center' }}>
                    <ColorPicker value={color} onChange={(e) => setColor(e.value)} ></ColorPicker>
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">圖片：</label>
                <div className="col-12 md:col-8">
                    <InputText value={icon} onChange={(e) => setIcon(e.target.value)} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">圖片大小：</label>
                <div className="col-12 md:col-8">
                    <InputNumber inputId="iconSize" value={iconSize} onValueChange={(e) => setIconSize(e.value)} mode="decimal" min={1} max={300} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">衛星視野角度：</label>
                <div className="col-12 md:col-8">
                    <InputNumber inputId="satelliteFOV" value={satelliteFOV} onValueChange={(e) => setSatelliteFOV(e.value)} mode="decimal" min={0} max={180} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">軌道圓邊數：</label>
                <div className="col-12 md:col-8">
                    <InputNumber inputId="orbitDetail" value={orbitDetail} onValueChange={(e) => setOrbitDetail(e.value)} mode="decimal" min={10} max={1000} style={{ width: "100%" }} />
                </div>
            </div>
            <Button label="新增衛星" loading={isLoad} disabled={!isCanSend} onClick={newSatelliteOnClick} className="p-button-rounded p-button-success" style={{ width: "100%" }} />
        </div>
    )
}

const EditSatelliteItem = (props) => {
    const [selectItem, setSelectItem] = useState(null);
    const [title, setTitle] = useState("");
    const [tleLine1, setTLELine1] = useState("");
    const [tleLine2, setTLELine2] = useState("");
    const [color, setColor] = useState("");
    const [icon, setIcon] = useState("");
    const [iconSize, setIconSize] = useState(30);
    const [satelliteFOV, setSatelliteFOV] = useState(45);
    const [orbitDetail, setOrbitDetail] = useState(90);
    const toast = useRef(null);
    useEffect(() => {
        if (selectItem === null) return;
        setTitle(selectItem.title);
        setTLELine1(selectItem.tleLine1);
        setTLELine2(selectItem.tleLine2);
        setColor(selectItem.color.split("#")[1]);
        setIcon(selectItem.icon);
        setIconSize(selectItem.iconSize);
        setSatelliteFOV(selectItem.satelliteFOV);
        setOrbitDetail(selectItem.orbitDetail);
    }, [selectItem]);

    const editOnClick = () => {
        if (selectItem === null) return;
        let item = {
            title: title,
            tleLine1: tleLine1,
            tleLine2: tleLine2,
            satelliteFOV: satelliteFOV,
            icon: icon,
            iconSize: iconSize,
            orbitDetail: orbitDetail,
            color: "#" + color
        };
        let oldItem = selectItem;
        props.editSatelliteItemChange(oldItem, item);
    }

    const deleteOnClick = () => {
        if (selectItem === null) return;
        props.deleteSatelliteItem(selectItem);
    }

    return (
        <div>
            <Toast ref={toast} />
            <Dropdown className="inputfield w-full" value={selectItem} options={props.satelliteItem} onChange={(e) => setSelectItem(e.value)} optionLabel="title" />
            <Divider />
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">衛星名稱：</label>
                <div className="col-12 md:col-8">
                    <InputText value={title} onChange={(e) => setTitle(e.target.value)} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">TLE1：</label>
                <div className="col-12 md:col-8">
                    <InputText value={tleLine1} onChange={(e) => setTLELine1(e.target.value)} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">TLE2：</label>
                <div className="col-12 md:col-8">
                    <InputText value={tleLine2} onChange={(e) => setTLELine2(e.target.value)} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label htmlFor="coverDropdown" class="col-12 mb-4 md:col-4 md:mb-0">衛星顏色</label>
                <div className="col-12 md:col-8" style={{ alignSelf: 'center' }}>
                    <ColorPicker value={color} onChange={(e) => setColor(e.value)} ></ColorPicker>
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">圖片：</label>
                <div className="col-12 md:col-8">
                    <InputText value={icon} onChange={(e) => setIcon(e.target.value)} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">圖片大小：</label>
                <div className="col-12 md:col-8">
                    <InputNumber inputId="iconSize" value={iconSize} onValueChange={(e) => setIconSize(e.value)} mode="decimal" min={1} max={300} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">衛星視野角度：</label>
                <div className="col-12 md:col-8">
                    <InputNumber inputId="satelliteFOV" value={satelliteFOV} onValueChange={(e) => setSatelliteFOV(e.value)} mode="decimal" min={0} max={180} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">軌道圓邊數：</label>
                <div className="col-12 md:col-8">
                    <InputNumber inputId="orbitDetail" value={orbitDetail} onValueChange={(e) => setOrbitDetail(e.value)} mode="decimal" min={10} max={1000} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <div className="col-12 md:col-6">
                    <Button label="更新衛星" className="p-button-rounded p-button-info" onClick={editOnClick} style={{ width: "100%" }} />
                </div>
                <div className="col-12 md:col-6">
                    <Button label="刪除衛星" className="p-button-rounded p-button-danger" onClick={deleteOnClick} style={{ width: "100%" }} />
                </div>
            </div>
        </div>
    )
}

const SatelliteHoveTimeSpan = (props) => {
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [filters, setFilters] = useState(null);
    const [isCanStart, setCanStart] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(5);
    const [, forceUpdate] = useReducer(num => num + 1, 0);
    const toast = useRef(null);

    useEffect(() => {
        if (startTime && endTime) {
            setCanStart(true);
            if (startTime.getTime() > endTime.getTime()) {
                setEndTime(null);
                return;
            }
        }
        else {
            setCanStart(false);
        }
    }, [startTime, endTime]);

    const HoveTimeSpanStart = () => {
        let param = {}
        param.begin = startTime;
        param.end = endTime;
        param.target = [
            // 臺灣本島及附屬島嶼領海基線
            new window.GeoPoint(122.00776,25.00828,0),
            new window.GeoPoint(122.1091,25.48385,0),
            new window.GeoPoint(122.08602,25.62986,0),
            new window.GeoPoint(122.0734,25.63262,0),
            new window.GeoPoint(121.50942,25.29145,0),
            new window.GeoPoint(121.09821,25.06821,0),
            new window.GeoPoint(121.03291,25.0326,0),
            new window.GeoPoint(119.54094,23.78755,0),
            new window.GeoPoint(119.31856,23.41189,0),
            new window.GeoPoint(119.31447,23.40348,0),
            new window.GeoPoint(119.31363,23.39928,0),
            new window.GeoPoint(119.31834,23.32469,0),
            new window.GeoPoint(119.41613,23.19327,0),
            new window.GeoPoint(120.35364,22.32381,0),
            new window.GeoPoint(120.82641,21.75632,0),
            new window.GeoPoint(121.61345,21.93839,0),
            new window.GeoPoint(121.61731,21.94968,0),
            new window.GeoPoint(121.52254,22.68542,0),
            new window.GeoPoint(121.5166,23.48331,0),
            new window.GeoPoint(121.86214,24.4805,0),
            new window.GeoPoint(121.90312,24.59935,0),
            new window.GeoPoint(121.96466,24.83951,0),
            // 東沙群島領海基線
            new window.GeoPoint(116.76549,20.76775,0),
            new window.GeoPoint(116.71016,20.73442,0),
            new window.GeoPoint(116.69632,20.69866,0),
            new window.GeoPoint(116.75465,20.59475,0),
            // 本島島內四極點與中點
            new window.GeoPoint(121.53676462886054, 25.299432322680975, 0),
            new window.GeoPoint(120.03509202810635, 23.10421942268097, 0),
            new window.GeoPoint(120.85775542788045, 21.897480322680966, 0),
            new window.GeoPoint(122.00266399850378, 25.011261022680966, 0),
            new window.GeoPoint(120.97962053009068, 23.97380812268097, 0)
        ];
        let value = [];
        let count = 0;
        if (props.selectSatelliteItem.length === 0) {
            toast.current.show({ severity: 'error', summary: '衛星模組提示', detail: "請開啟衛星以使用分析！" });
            return;
        }
        props.selectSatelliteItem.forEach((item) => {
            param.fov = parseFloat(item.satelliteFOV / 2);
            item.entity.getHoveTimeSpan(param, (data) => {
                if (data.success) {
                    for (let i = 0; i < data.date.length; i++) {
                        value.push({
                            id: count,
                            date: data.date[i],
                            positions: data.positions[i],
                            satellite: item.title
                        })
                        count++;
                    }
                    toast.current.show({ severity: 'success', summary: '衛星模組提示', detail: item.title + "衛星過頂計算完成！" });
                    forceUpdate();
                }
                else {
                    toast.current.show({ severity: 'error', summary: '衛星模組提示', detail: data.message });
                }
                props.setHoveTimeSpanValue(value);
                return;
            })
        })
    }

    const satelliteBodyTemplate = (rowData) => {
        return rowData.satellite;
    }

    const dateBodyTemplate = (rowData) => {
        return rowData.date.toLocaleString();
    }

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />
    }

    const onCustomPage = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    }

    const paginatorTemplate = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 }
            ];

            return (
                <React.Fragment>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const onRowSelect = (event) => {
        let pos = new window.GeoPoint(event.data.positions.x, event.data.positions.y, event.data.positions.z + 500000);
        let v = new window.Geo3DPoint(0, 0, -1);
        let up = new window.Geo3DPoint(0, 1, 0);
        let camera = new window.ov.Camera(pos, v, up);
        window.main.OView.gotoCamera(camera, false);
        window.widgetTimeline.updateTime(event.data.date);
    }

    return (
        <Card subTitle="過頂分析以中華民國領海基線為基準，並以分鐘為單位進行分析。">
            <Toast ref={toast} />
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">開始時間：</label>
                <div className="col-12 md:col-8">
                    <Calendar id="startTimeCalendar" value={startTime} onChange={(e) => setStartTime(e.value)} showTime showSeconds showButtonBar style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label class="col-12 mb-4 md:col-4 md:mb-0">結束時間：</label>
                <div className="col-12 md:col-8">
                    <Calendar id="endTimeCalendar" value={endTime} onChange={(e) => setEndTime(e.value)} minDate={startTime} showTime showSeconds showButtonBar style={{ width: "100%" }} />
                </div>
            </div>
            <Divider />
            <div className="field grid">
                <div className="col-12 md:col-6">
                    <Button label="計算過頂" className="p-button-rounded p-button-info" disabled={!isCanStart} onClick={HoveTimeSpanStart} style={{ width: "100%" }} />
                </div>
                <div className="col-12 md:col-6">
                    <Button label="清除結果" className="p-button-rounded p-button-danger" onClick={() => props.setHoveTimeSpanValue([])} style={{ width: "100%" }} />
                </div>
            </div>
            <Divider />
            <DataTable value={props.hoveTimeSpanValue} paginator paginatorTemplate={paginatorTemplate} first={first} rows={rows} onPage={onCustomPage} paginatorClassName="justify-content-end"
                filters={filters} filterDisplay="row" className="p-datatable-customers" globalFilterFields={["satellite", "date"]}
                selectionMode="single" selection={selectedItem} onSelectionChange={e => setSelectedItem(e.value)} onRowSelect={onRowSelect}
                showGridlines dataKey="id" responsiveLayout="scroll" emptyMessage="沒有過頂資料。">
                <Column filterField="satellite" header="衛星" body={satelliteBodyTemplate} filter style={{ minWidth: '12rem' }} />
                <Column filterField="date" header="經過台灣本島上空時間" body={dateBodyTemplate} dataType="date" filter filterElement={dateFilterTemplate} style={{ minWidth: '12rem' }} />
            </DataTable>
        </Card>
    )
}